import { SET_WIS_INVENTORY } from '../actions/types';

const initialState = null;

const WIS = (state = initialState, action) => {
	switch (action.type) {
		case SET_WIS_INVENTORY:
			return action.payload;
		default:
			return state;
	}
};

export default WIS;
